<template>
  <div>
    <v-dialog
      v-model="show"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <DeleteDialog
        :content="deleteDialogContent"
        :button-loading="deleteButtonLoading"
        :hide-delete-button="false"
        @delete="deleteTestamentaryTrust"
        @dialogClosed="closeAndReset"
      />
    </v-dialog>
  </div>
</template>

<script>
  import DeleteDialog from '../common/DeleteDialog.vue';

  export default {
    name: 'TestamentaryTrustDialog',
    components: {
      DeleteDialog,
    },
    props: {
      value: Boolean,
    },
    data() {
      return {
        deleteButtonLoading: false,
      };
    },
    computed: {
      loading() {
        return this.buttonLoading;
      },
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },

      deleteDialogContent() {
        return {
          title: 'Remove testamentary trust',
          text: 'Are you sure you want to remove your testamentary trust? <br/><br/><strong>Warning:</strong> Any bequests left to this trust will also be removed.',
          buttonText: 'Yes, Remove Testamentary Trust',
        };
      },
    },
    methods: {
      deleteTestamentaryTrust() {
        this.closeDialog();
      },
      closeAndReset() {
        this.$emit('dontDeleteTestamentaryTrust');
        this.closeDialog();
      },
      closeDialog() {
        this.show = false;
        this.deleteButtonLoading = true;
        setTimeout(() => this.clearDialog(), 300);
      },
      clearDialog() {
        this.deleteButtonLoading = false;
      },
    },
  };
</script>
